// This file was auto-generated by Fern from our API Definition.
export const GetMountFilesRequestOrder = {
    Recent: "recent",
    Name: "name",
    Path: "path",
};
